import React from "react";
import { useState } from "react";
import { Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Box, Typography } from "@mui/material";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Edit } from "../../../../../assets/images/edit.svg";
import CustomPagination from "../../../../../components/CustomPagination";
import Modal from "../../../../../components/Modal";
import styles from "./style";
import { formatDate } from "../../../../../utils/DateFormat";

const SupplierList = ({ data, count, page, setPage, handleDelete }) => {
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState()
  const navigate = useNavigate()

  const handleNavigate = (item) => {
    navigate("/dashboard/editBill", { state: { item } })
  }

  const handleNavigateView = (item) => {
    navigate("/dashboard/billView", { state: { item } })
  }

  const deleteData = (item) => {
    setValue(item);

  }
  const handleDeleteItem = () => {
    handleDelete(value)
    setOpen(false);
  };

  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={styles.TableHead}>Bill</TableCell>
              <TableCell sx={styles.TableHead}>Bill Date</TableCell>
              <TableCell sx={styles.TableHead}>Due Date</TableCell>
              <TableCell sx={styles.TableHead}>Amount Due</TableCell>
              <TableCell sx={styles.TableHead}>Status </TableCell>
              <TableCell sx={styles.TableHead}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  <Typography variant="h6">No data</Typography>
                </TableCell>
              </TableRow>
            ) : (
              data?.map((item, index) => (
                <TableRow key={index}>
                  <TableCell sx={styles.tabledata}>{item?.billNo || ''}</TableCell>
                  <TableCell sx={styles.tabledata}>{formatDate(item?.billDate || 'N/A')}</TableCell>
                  <TableCell sx={styles.tabledata}>{formatDate(item?.dueDate || 'N/A')}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.amountDue?.toFixed(2) || 'N/A'}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.status || 'Pending'}</TableCell>
                  <TableCell sx={styles.tabledata}>
                    <Box sx={styles.tableActiondata}>
                      <Edit onClick={() => handleNavigate(item)} />
                      <RemoveRedEyeOutlinedIcon onClick={() => handleNavigateView(item)} sx={{ color: "gray", fontSize: "1.5rem" }} />
                      <DeleteOutlineIcon onClick={() => { deleteData(item?._id), setOpen(true); }} sx={{ color: "#878787" }} />
                    </Box>
                  </TableCell>
                </TableRow>
              )))}
          </TableBody>
        </Table>
        {data &&
          <CustomPagination
            pageCount={count}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            totalItems={data.length}
          />}
      </TableContainer>
      <Modal open={open} setOpen={setOpen} deletetText={"Delete"} cancelText={"Cancel"} title={"Delete Bill"} handleDelete={handleDeleteItem}>
        <Box>
          <Typography>Are you sure you want to Delete?</Typography>
        </Box>
      </Modal>

    </>
  );
};
export default SupplierList;
